<modal-container
  #modal
  [ignoreBackdropClick]="true"
  (hide)="onHideChildModal()"
  [headerTitle]="('modal-existing-positions.title' | translate) + ' ' + product?.name"
>
  <ng-container class="modal-button-show">
    <button
      class="link-bold product-name-nowrap-wrapper stock-positions-absolute-2"
      style="border: none"
      (click)="showChildModal()"
    >
      {{ 'modal-existing-positions.open-modal' | translate }}
    </button>
  </ng-container>
  <ng-container class="modal-body-content">
    <div class="container-fluid ps-0 pe-0">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      @if (!loading) {
        <div class="stock-operation-card--content">
          <div class="card">
            <form-row-toggle
              [label]="'modal-existing-positions.show-only-occupied-position.toggle-title'"
              [model]="showOnlyOccupiedPositions"
              (modelChange)="showOnlyOccupiedPositions = $event; shownPositionsChanged()"
              [classesString]="'text-nowrap'"
            ></form-row-toggle>
            <div>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    @if (!productDepots?.length) {
                      <tr>
                        {{
                          'modal-existing-positions.no-items' | translate
                        }}
                      </tr>
                    }
                    @for (productDepot of productDepots; track productDepot) {
                      <tr>
                        <td class="no-hover">
                          <div>
                            <span class="font-weight">{{ productDepot.position }}</span>
                          </div>
                          <div class="input-group-append flex-wrap product-center">
                            <div class="product-details">
                              {{ 'product.expirationDate' | translate }}:
                              <span>{{ productDepot.expirationDate | fmtDate: 'dd.MM.yyyy' }}</span>
                            </div>
                            <div class="product-details">
                              {{ 'product.batch' | translate }}:
                              <span>{{ productDepot.expirationDate }}</span>
                            </div>
                          </div>
                        </td>
                        <td class="no-hover text-center text-nowrap">
                          <span class="quantityStock badge badge-pill" data-cy="pDepot-quantityStock">{{
                            productDepot.quantityStock | number: '1.0-2' | replaceCommaToDot
                          }}</span>
                          <span class="quantityReservation badge badge-pill" data-cy="pDepot-quantityReservation">{{
                            productDepot.quantityReservation | number: '1.0-2' | replaceCommaToDot
                          }}</span>
                          <span class="quantityAvailable badge badge-pill" data-cy="pDepot-quantityAvailable">
                            {{ productDepot.quantityAvailable | number: '1.0-2' | replaceCommaToDot }}</span
                          >
                        </td>
                        <td class="no-hover" style="text-align: right">
                          <btn
                            [isLoading]="loading"
                            [classes]="['btn-second', 'btn-sm']"
                            [icon]="'far-check'"
                            [label]="'select'"
                            (onEvent)="positionSelected(productDepot)"
                            [title]="'select' | translate"
                          ></btn>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-container>
</modal-container>
